'use strict';

var normaliseGqlConnectOptions = require('./normaliseGqlConnectOptions.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Fetches data from a GraphQL endpoint using the provided options.
 *
 * @param options - The options for fetching the GraphQL data.
 * @returns A Promise that resolves to the fetched data.
 */ async function fetchGql(options) {
    const { endpoint, token, body, query, variables } = normaliseGqlConnectOptions(options);
    const data = await fetch(endpoint, {
        method: 'POST',
        headers: _extends({
            'Content-Type': 'application/json'
        }, token && {
            authorization: `Bearer ${token}`
        }),
        body: JSON.stringify(body || {
            query: query,
            variables: variables
        })
    });
    const json = await data.json();
    return new Response(JSON.stringify(json), {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

module.exports = fetchGql;
